export default __webpack_public_path__ + "static/media/buffalo.e6ec7e26.png";